import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { DataSourceRequestState, DataResult } from '@progress/kendo-data-query';
import { AppConstant } from 'src/app/app.constant';
import { Attachment } from 'src/app/_metronic/core/classes/core.class';

@Injectable({
  providedIn: 'root'
})
export class CurriculumService {
  apiUrl: string;
  chapterData = {}
  constructor(private httpClient: HttpClient,
    private appConstant: AppConstant) {
    this.apiUrl = this.appConstant.getUrl()
  }

  manageChapter(chapter) {
    return this.httpClient.post(`${this.apiUrl}/manageSyllabus`, chapter).pipe(
      map((response: any) => {
        return response;
      }))
  }

  getSyllabusById(Id) {
    return this.httpClient.get(`${this.apiUrl}/getSyllabusById/` + Id).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  getCurriculumRegister(classId: number, subjectId: number) {
    return this.httpClient.get(`${this.apiUrl}/curriculumRegister/` + classId + '/app/' + subjectId).pipe(
      map((response: any) => {
        return {
          data: response.data,
          total: response.total
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>;
  }

  updateSyllabusStatus(topicData) {
    return this.httpClient.post(`${this.apiUrl}/updateSyllabusStatus`, topicData).pipe(
      map((response: any) => {
        return response;
      }))
  }
  getAllCurriculumExel(branchId: number) {
    const params = {
      branchId: branchId,
    }
    return new Promise((resolve, reject) => {
      this.httpClient.post(`${this.apiUrl}/curriculumList/`, params).pipe(
        map(res => res))
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }


  // public getChapterList(): Observable<DataResult> {
  //   return this.httpClient.get(`${this.apiUrl}/getAllSyllabus/`).pipe(
  //     map((response: any) => {
  //       return {
  //         data: response.data,
  //         total: response.total
  //       } as any
  //     })
  //   ) as any as Observable<any>
  // }

  async getChapterList(): Promise<any[]> {
    return (await this.httpClient.get<GridDataResult>(`${this.apiUrl}/getAllSyllabus/`).toPromise()).data;
  }

  public getCurriculum(branchId: number, classId: number, subjectId: number, state: DataSourceRequestState): Observable<DataResult> {
    let params = {
      branchId: branchId,
      classId: classId,
      subjectId: subjectId,
      state: state
    }
    return this.httpClient.post(`${this.apiUrl}/curriculumList/`, params).pipe(
      map((response: any) => {
        return {
          data: response.data,
          total: response.total
        } as any
      })
    ) as any as Observable<any>
  }

  bulkInsert(CurriculumData) {
    let Param = {
      DataToImport: CurriculumData
    }
    return this.httpClient.post(`${this.apiUrl}/bulkImportSyllabus`, Param).pipe(
      map((response: any) => {
        return response;
      }))
  }
  addAttachments(attachments: Attachment[]) {
    return new Promise((resolve, reject) => {
      this.httpClient.post(`${this.apiUrl}/fileBulkUpload`, attachments).pipe(
        map(res => res))
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }
  deleteAttachments(attachments: Attachment) {
    return this.httpClient.post(`${this.apiUrl}/fileBulkDelete`, attachments).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
}
